import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import { useCallback } from 'react';
import type { RazorpayCheckoutActionOptions, RazorpayCheckoutResponse } from './types';

export function useRazorpay() {
  const { showSnackbar } = useSnackbar();
  const { t } = useTranslation(['common']);

  const checkout = useCallback(
    (_options?: RazorpayCheckoutActionOptions): Promise<RazorpayCheckoutResponse | null> => {
      showSnackbar({
        color: 'warning',
        title: t('common:Razorpay.NativeOnly'),
      });
      return Promise.resolve(null);
    },
    [showSnackbar, t],
  );

  return {
    isEnabled: false,
    checkout,
  };
}
